export const validationTypes = {
  alphaNumeric: 'alphaNumeric',
  commaSeparatedEmailAddress: 'commaSeparatedEmailAddress',
  digits: 'digits',
  dates: 'dates',
  emailAddress: 'emailAddress',
  domain: 'domain',
  minLength: 'minLength',
  maxLength: 'maxLength',
  phoneNumber: 'phoneNumber',
  phoneNumberPlain: 'phoneNumberPlain',
  alphaAndCharacters: 'alphaAndCharacters',
  alphaNumericAndCharacters: 'alphaNumericAndCharacters',
  alpha: 'alpha',
  zipCode: 'zipCode'
};

export const regexPatterns = {
  [validationTypes.alphaNumeric]: /^[a-zA-Z0-9]+$/,
  [validationTypes.commaSeparatedEmailAddress]: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/,
  [validationTypes.digits]: /^[0-9]+$/,
  [validationTypes.emailAddress]: /^[A-Za-z0-9](([+_.-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([.-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/,
  [validationTypes.domain]: /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+\.[a-zA-Z]{2,}$/,
  [validationTypes.phoneNumber]: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
  [validationTypes.phoneNumberPlain]: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/,
  [validationTypes.dates]: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
  [validationTypes.alphaAndCharacters]: /^[a-zA-Z \-,./'()&_]*$/,
  [validationTypes.alphaNumericAndCharacters]: /^[a-zA-Z0-9 \-,./'()&_]*$/,
  [validationTypes.alpha]: /^[A-Za-z]+$/,
  [validationTypes.zipCode]: /^[a-zA-Z0-9 -]*$/
};

const validationObjects = {
  [validationTypes.alphaNumeric]: {
    pattern: {
      value: regexPatterns[validationTypes.alphaNumeric],
      message: 'Only alphanumeric characters allowed'
    }
  },
  [validationTypes.commaSeparatedEmailAddress]: {
    pattern: {
      value: regexPatterns[validationTypes.commaSeparatedEmailAddress],
      message: 'Emails must be correct format and list must be comma separated and cannot end in a comma'
    }

  },
  [validationTypes.digits]: {
    pattern: {
      value: regexPatterns.digits,
      message: 'Only digits allowed'
    }
  },
  [validationTypes.emailAddress]: {
    pattern: {
      value: regexPatterns[validationTypes.emailAddress],
      message: 'Incorrect Email Format'
    }
  },
  [validationTypes.domain]: {
    pattern: {
      value: regexPatterns[validationTypes.domain],
      message: 'Incorrect Domain Format'
    }
  },
  [validationTypes.minLength]: {},
  [validationTypes.maxLength]: {},
  [validationTypes.phoneNumber]: {
    pattern: {
      value: regexPatterns[validationTypes.phoneNumber],
      message: 'Incorrect phone number format'
    }
  },
  [validationTypes.phoneNumberPlain]: {
    pattern: {
      value: regexPatterns[validationTypes.phoneNumberPlain],
      message: 'Incorrect phone number format'
    }
  },
  [validationTypes.dates]: {
    pattern: {
      value: regexPatterns[validationTypes.dates],
      message: 'Must be a valid date in the format MM/DD/YYYY'
    }
  },
  [validationTypes.alphaAndCharacters]: {
    pattern: {
      value: regexPatterns[validationTypes.alphaAndCharacters],
      message: 'Only letters, spaces, and ,./\'() characters allowed'
    }
  },
  [validationTypes.alphaNumericAndCharacters]: {
    pattern: {
      value: regexPatterns[validationTypes.alphaNumericAndCharacters],
      message: 'Only letters, numbers, spaces, and -,.() characters allowed'
    }
  },
  [validationTypes.alpha]: {
    pattern: {
      value: regexPatterns[validationTypes.alpha],
      message: 'Only letters allowed'
    }
  },
  [validationTypes.zipCode]: {
    pattern: {
      value: regexPatterns[validationTypes.zipCode],
      message: 'Postal code can include letters, numbers, dashes, and spaces'
    }
  }
};

export const getValidationObject = type => {
  if (!validationTypes[type]) {
    throw new Error(`Validation Object of type ${type} does not exist`);
  }

  return validationObjects[type];
};
